import { useInfiniteQuery } from "@tanstack/react-query";

import { casinoGamesTreeGroupQueryKey } from "./casinoConfigurationGamesQueryKeys";
import { fetchCasinoGamesTreeGroupPage } from "./fetchCasinoGamesTreeGroupPage";

export function useCasinoGamesTreeGroup(
  provider: string | null,
  sub: string | null,
  enabled: boolean,
  search: string,
) {
  const resolvedProvider = provider ?? "";
  const resolvedSub = sub ?? "";
  const resolvedSearch = search.trim();

  return useInfiniteQuery({
    queryKey: casinoGamesTreeGroupQueryKey(
      resolvedProvider,
      resolvedSub,
      resolvedSearch,
    ),
    queryFn: ({ pageParam }) =>
      fetchCasinoGamesTreeGroupPage(
        resolvedProvider,
        resolvedSub,
        pageParam as number,
        resolvedSearch,
      ),
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.meta?.has_next ? lastPage.meta.page + 1 : undefined,
    enabled: Boolean(enabled && resolvedProvider && resolvedSub),
    staleTime: 60 * 1000,
  });
}
